export default {"src":"/_next/static/media/nebl.2bb281ab.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};